import { RequireChildrenFor } from "@omni/types/components/utils/children.types";
import { Button } from "@omni/ui/components/Button/button.component";
import { cn } from "@omni/utils/styles";
import { useEffect } from "react";
import { useSelector } from "react-redux";

import { Flyout } from "@/components/General/Flyout/flyout";
import { getQuery } from "@/redux/modules/value/search/search.selectors";
import { useGranite } from "@/redux/modules/value/translations/translations.provider";
import { useBreakpoint } from "@/utils/breakpoints/breakpoints.provider";
import { getTagZoneIdFor } from "@/utils/tagging/tag.utils";

import { useProductResultsContext } from "../../../context/productResults.context";

type MobileFacetsProps = RequireChildrenFor<{}>;

const MobileFacets = ({ children }: MobileFacetsProps) => {
    const { mobileFacetsOpen, setMobileFacetsOpen } =
        useProductResultsContext();

    const { t } = useGranite();

    const query = useSelector(getQuery);

    const { breakpoints } = useBreakpoint();
    const isMobile = !breakpoints.lg;

    const close = () => {
        if (!mobileFacetsOpen) return;
        setMobileFacetsOpen(() => false);
    };

    // biome-ignore lint/correctness/useExhaustiveDependencies: <TODO>
    useEffect(() => {
        close();
    }, [query]);

    if (!isMobile) {
        return null;
    }

    return (
        <Flyout
            open={mobileFacetsOpen}
            className={cn("tw:lg:hidden")}
            onClose={close}
            {...getTagZoneIdFor("search-facets")}
        >
            <Flyout.Content>{children}</Flyout.Content>
            <Flyout.Controls>
                <Button
                    type={"button"}
                    color={"link"}
                    className={"cursor-pointer"}
                    onClick={close}
                >
                    {t("search.refinements.mobile.close")}
                </Button>
                <Flyout.Controls.CloseButton>
                    {t("search.refinements.mobile.apply")}
                </Flyout.Controls.CloseButton>
            </Flyout.Controls>
        </Flyout>
    );
};

export { MobileFacets };
